// @flow
import React, { useEffect, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { withTranslation } from 'react-i18next';
import { Button, withTheme } from '@material-ui/core';

import { analytics } from '../firebase';

type Props = {
  classes?: Object,
  countdown: number, // in seconds
  countdownBegin: number, // as returned by Date.now(), if 0 the snackbar won't show
  message: String, // $min will be replaced with minutes, and $sec with seconds.
  theme: Object,
  additionalActionMessage: string,
  additionalActionUrl: string,
  appSubmittedTypeform: Object,
};

function SnackbarWithCountdown(props: Props) {
  const {
    classes,
    countdown,
    countdownBegin,
    message,
    theme,
    additionalActionMessage,
    additionalActionUrl,
    appSubmittedTypeform,
  } = props;
  const [timeLeft, setTimeLeft] = useState(countdown);
  const [closed, setClosed] = useState(true);
  const [formattedMins, setFormattedMins] = useState('0');
  const [formattedSecs, setFormattedSecs] = useState('00');
  useEffect(() => {
    // If the countdownBegin changed, we un-close the snackbar.
    if (countdownBegin) setClosed(false);
  }, [countdownBegin]);
  useEffect(() => {
    const changeTimeLeft = () => {
      const timeElapsed = Date.now() - countdownBegin;
      const currentTimeLeft = Math.floor(Math.max(0, props.countdown - timeElapsed / 1000));
      setTimeLeft(currentTimeLeft);
      setFormattedMins(Math.floor(currentTimeLeft / 60).toString());
      const currentSecLeft = currentTimeLeft % 60;
      // 11 -> '11', but '6' -> '06'. JS does not have nice format strings :(
      setFormattedSecs((currentSecLeft < 10 ? '0' : '') + currentSecLeft.toString());
    };
    changeTimeLeft();
    // We want it to update at lest every 1s, to have a consistent 1s
    // countdown. However, setInterval guarantees it will be executed after
    // at least the specified time happens. So it's better to execute a little
    // more often, to catch every second.
    const interval = setInterval(changeTimeLeft, 900);
    return () => clearInterval(interval);
  });

  return (
    <div>
      <Snackbar
        classes={classes}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={!closed && timeLeft > 0}
        onClose={() => {}}
      >
        <SnackbarContent
          aria-describedby="client-snackbar"
          message={
            // eslint-disable-next-line
            <span id="client-snackbar">{message.replace('$min', formattedMins).replace('$sec', formattedSecs)}</span>
          }
          style={{
            backgroundColor: theme.palette.ava.accent,
          }}
          action={[
            <Button
              key="additional"
              href={additionalActionUrl}
              onClick={() => {
                setClosed(true);
                analytics.logEvent('app_submitted_typeform', {
                  ...appSubmittedTypeform,
                });
              }}
              target="_blank"
              rel="noreferrer noopener"
              variant="outlined"
              style={{
                borderColor: 'white',
                borderRadius: 20,
                color: 'white',
                fontSize: '0.9em',
                textTransform: 'none',
              }}
            >
              {additionalActionMessage}
            </Button>,
            <IconButton key="close" aria-label="Close" color="inherit" onClick={() => setClosed(true)}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </div>
  );
}

export default withTheme(withTranslation()(SnackbarWithCountdown));
